module.exports = "/_next/static/images/Daniela_Jurja-d18edd343c2d5ea2401954f05d3e4610.webp";